// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__roqIt","btn_disabled":"styles_btn_disabled__1u_r7","text":"styles_text__2628_"};